var productMetaJson = JSON.parse(
  document.getElementById("product-meta-json").textContent,
);
$(document).on("click", "#dropdown_info", function () {
  window.location.hash = "#popup";
  $(".Weitere-model-main").addClass("model-open");
  $("body").addClass("popup_active");
});
$(document).on("click", ".Weitere_close_btn, .Weitere_bg_overlay", function () {
  if (window.location.hash) {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search,
    );
  }
  $(".Weitere-model-main").removeClass("model-open");
  $("body").removeClass("popup_active");
});

$(document).on("click", "#halskette_short_textnain", function () {
  window.location.hash = "#popup";
  $(".Handzeichnung-model-main").addClass("model-open");
  $("body").addClass("popup_active");
});
$(document).on(
  "click",
  ".Handzeichnung_close_btn, .Handzeichnung_bg_overlay",
  function () {
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search,
      );
    }
    $(".Handzeichnung-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
  },
);

$(document).on("click", "#Zeichnungsstil_dropdown_info", function () {
  window.location.hash = "#popup";
  $(".Zeichnungsstil-model-main").addClass("model-open");
  $("body").addClass("popup_active");
});
$(document).on(
  "click",
  ".Zeichnungsstil_close_btn, .Zeichnungsstil_bg_overlay",
  function () {
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search,
      );
    }
    $(".Zeichnungsstil-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
  },
);

//orphan btn open popup
$(document).on("change", "#Farbig", function () {
  if ($(this).is(":checked")) {
    $(".halskette-product-add-btn").removeClass("disabled");
    $(".error").hide();
    $(".line-item-property__field.radio-buttons").removeClass("error-text");
    $("#Ohren").prop("checked", false);
    // $(".upload_photo_container").show();
    // $(".halskette_short_text1").show();
    $("#Nein").prop("checked", true);
    $('[data-name="properties[Handzeichnung als Datei]"]').each(function () {
      $(this).attr("name", $(this).data("name"));
    });
    // $('[data-name="properties[Foto]"]').attr("name", "properties[Foto]");
  } else {
    // $(".halskette-product-add-btn").addClass("disabled");
    $('input[name="properties[Handzeichnung als Datei]"]').prop(
      "checked",
      false,
    );
    $(".upload_photo_container").hide();
    $(".halskette_short_text1").hide();
    $('[data-name="properties[Handzeichnung als Datei]"]').removeAttr("name");
    // $('[name="properties[Foto]"]').attr("data-name", "properties[Foto]");
    // $('[name="properties[Foto]"]').removeAttr("name");
  }
  getPrice();
});

$(document).on("click", "#Ohren", function () {
  if ($(this).is(":checked")) {
    $("#Farbig").prop("checked", false);
    // $(".upload_photo_container").hide();
    // $(".halskette_short_text1").hide();
    $("#Nein").prop("checked", true);
    $('[data-name="properties[Handzeichnung als Datei]"]').removeAttr("name");
    // $('[name="properties[Foto]"]').attr("data-name", "properties[Foto]");
    // $('[name="properties[Foto]"]').removeAttr("name");
  }

  var id = $("[data-product-select]").val();
  var selectedlength = $(".halskette_option .list_item").length;
  var selectedValueNbr = $(".halskette_option .list_item")
    .find(".list_item_value")
    .attr("data-number");
  if (!selectedValueNbr) {
    var selectedValueNbr = 1;
  }
  console.log(selectedValueNbr);
  var valueLen = parseInt(selectedValueNbr);

  if (selectedValueNbr > 1) {
    $(".popup_short_texts").show();
    $(".Ruckseitengravur-model-main .backpopup_more_text").show();
  } else {
    $(".popup_short_texts").hide();
    $(".Ruckseitengravur-model-main .backpopup_more_text").hide();
  }
  $(".Ruckseitengravur-model-main .wrap_image_container img").hide();
  $(
    '.Ruckseitengravur-model-main .wrap_image_container img[data-id="' +
      id +
      '"]',
  ).show();

  var splide = new Splide(".first_slider", {
    pagination: false,
    drag: false, // Disable swipe functionality
  });
  splide.mount();
  if (selectedValueNbr == 1) {
    $(".splide__arrows").hide();
    $(".count-item").hide();
  } else {
    $(".splide__arrows").show();
    $(".count-item").show();
  }

  setTimeout(function () {
    window.location.hash = "#popup";
    $(".Ruckseitengravur-model-main").addClass("model-open");
    $("body").addClass("popup_active");
    touchScroll(".popup_fonts");
  }, 500);
});

// back side cancel/skip btn open popup

$(document).on(
  "click",
  ".halskette_backname_texts .fflagship-collapsable-header-button2",
  function () {
    var id = $("[data-product-select]").val();
    var selectedlength = $(
      ".select-trigger .selected-option .list_item",
    ).length;
    $(".Ruckseitengravur-model-main .wrap_image_container img").hide();
    $(
      '.Ruckseitengravur-model-main .wrap_image_container img[data-id="' +
        id +
        '"]',
    ).show();
    setTimeout(function () {
      window.location.hash = "#popup";
      $(".Ruckseitengravur-model-main").addClass("model-open");
      $("body").addClass("popup_active");
    }, 500);
  },
);

$(document).on("click", ".Farbig_close_btn, .Farbig_bg_overlay", function () {
  if (window.location.hash) {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search,
    );
  }
  $(".Farbig-model-main").removeClass("model-open");
  $("body").removeClass("popup_active");
});

$(document).on(
  "click",
  ".Ruckseitengravur_close_btn, .Ruckseitengravur_bg_overlay",
  function () {
    var farbig = $(".popup_name_inputproperties").val();
    if (!farbig) {
      $('[name="Name"]').prop("checked", false);
    }
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search,
      );
    }
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
  },
);

$(document).on("click", "#upload_info", function () {
  window.location.hash = "#popup";
  $(".aufFoto-model-main").addClass("model-open");
  $("body").addClass("popup_active");
});
$(document).on("click", ".aufFoto_close_btn, .aufFoto_bg_overlay", function () {
  if (window.location.hash) {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search,
    );
  }
  $(".aufFoto-model-main").removeClass("model-open");
  $("body").removeClass("popup_active");
});

$(document).on("click", ".select-trigger", function () {
  $(this).parents(".custom-select").find(".options").slideToggle("fast");
  $(this)
    .parents(".custom-select")
    .find("#halskette_select")
    .toggleClass("selected_open");
  $(this).toggleClass("selector_open");
});

$(document).on("click", "#halskette_select.options li", function () {
  var selectedOption = $(this).html();
  var selectedValue = $(this).attr("value");
  var dataPriceValue = $(this).find(".list_item_value").attr("data-valuePrice");
  $(".Ruckseitengravur-model-main .frontname").removeClass("name_active");
  $(".Farbig-model-main .frontname").removeClass("name_active");
  var selectedDataVal = $(this)
    .parents(".halskette_selecteditems")
    .find(".select-trigger .selected-option .list_item .list_item_value")
    .attr("data-value");
  $(".halskette_backname_texts .halskette_rucks_texts").html("");
  $(".halskette_backname_texts .backnamecancel_btn").show();
  $(".halskette_backname_texts .halskette_name_btn .Ohren-input").show();

  $(".Ruckseitengravur-model-main .popup_name_images").html("");
  $(".Ruckseitengravur-model-main .popup_name_inputs").val("");

  $(".Farbig-model-main .popup_name_image").html("");
  $(".Farbig-model-main .popup_name_inputs").val("");

  $(".Ruckseitengravur-model-main #frontname_1").addClass("name_active");
  $(".Farbig-model-main #frontname_1").addClass("name_active");
  $(".halskette_backname_texts .halskette_header").show();
  $(".halskette_backname_texts .halskette_input_first").show();
  $(".halskette_backname_texts .halskette_rucks_cancel_databtn").html("");
  $(this)
    .parents(".halskette_selecteditems")
    .find(".selected-option")
    .html(selectedOption);
  $(".halskette_personen").val(
    $(this).find(".list_item_value").attr("data-valuePrice"),
  );
  $("#halskette_select.options").slideUp("fast");
  $("#halskette_select.options").removeClass("selected_open");
  $(this)
    .parents(".custom-select")
    .find(".select-trigger")
    .removeClass("selector_open");
//   checkError();
  getPrice();
});

$(document).on(
  "click",
  ".Ruckseitengravur-model-main .popup_fonts .frontname",
  function () {
    $(this)
      .parents(".popup_fonts")
      .find(".frontname")
      .removeClass("name_active");
    $(this).addClass("name_active");
    var fontName = $(this).attr("data-named");

    var fontimageName = $(this).attr("data-imagename");
    $(this)
      .parents(".inner-html")
      .find("#popup_name_images")
      .attr("data-font", fontName);
    $(this)
      .parents(".inner-html")
      .find("#popup_name_images")
      .attr("class", fontimageName);

    var inputValue = $(this)
      .parents(".inner-html")
      .find(".frontnameinput_1")
      .val();
    var convertedValue = inputValue;
    var elements = $(this)
      .parents(".inner-html")
      .find(".frontname_4.name_active");
    if (elements.length > 0) {
      var words = inputValue.split(" ");
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        var wordFirstCharacter = word.charAt(0);
        var wordRestOfText = word.substr(1).toLowerCase();
        words[i] = wordFirstCharacter + wordRestOfText;
      }
      var convertedValue = words.join(" ");
      $(this)
        .parents(".inner-html")
        .find(".frontnameinput_1")
        .val(convertedValue);
    }
    $(this)
      .parents(".inner-html")
      .find("#popup_name_images")
      .html(convertedValue);
    updateFontSize($(this).parents(".inner-html").find(".frontnameinput_1"));
  },
);

// name backside popup save btn 1st
$(document).on(
  "click",
  ".Ruckseitengravur-model-main .image_save_btn",
  function () {
    $(".Farbig-input").hide();
    $(".halskette_backname_texts .halskette_rucks_texts").html("");
    $(".halskette_backname_texts .halskette_rucks_cancel_databtn").html("");
    $('[name="properties[Rückseite überspringen]"]').val("");
    var fullHtml = "";
    $(this)
      .parents(".back-popup-js")
      .find(".inner-html")
      .each(function (index) {
        console.log(index);
        var nameInputVal = $(this).find(".popup_name_inputs").val();
        console.log(nameInputVal);
        var fontName = $(this)
          .find(".frontname.name_active")
          .attr("data-fontname");
        var fontNameId = $(this)
          .find(".frontname.name_active")
          .attr("data-nameid");
        var indexPlus = index * 1 + 1;
        var indexPlusText = indexPlus;
        if (indexPlus == 1) {
          var indexPlusText = "";
        }
        /*var Zeichenstil = $('[name="properties[Zeichenstile]"]:checked').val();*/
        var Zeichenstil;
        if ($('[name="properties[Zeichenstile]"]:checked').length > 0) {
          Zeichenstil = $('[name="properties[Zeichenstile]"]:checked').val();
        } else if ($('[name="properties[drawing style]"]:checked').length > 0) {
          Zeichenstil = $('[name="properties[drawing style]"]:checked').val();
        }
        if (nameInputVal != "") {
          $(".halskette_backname_texts .halskette_rucks_texts").show();
          $(".halskette_backname_texts .halskette_input_first").show();
          $(".halskette_backname_texts .halskette_header").show();
          fullHtml =
            fullHtml +
            '<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="engraving-messagesection row" data-autom="engraving-message-' +
            indexPlus +
            '"><div class="engraving-messagesection-item"><span class="engraving-name">Name:&nbsp</span><input class="popup_name_inputproperties inputsproperty_' +
            indexPlus +
            '" type="hidden" value="' +
            nameInputVal +
            '" name="properties[Name ' +
            indexPlusText +
            ']"><input class="popup_font_inputproperties fontproperty_' +
            indexPlus +
            '" type="hidden" value="' +
            fontName +
            '" name="properties[_' +
            Zeichenstil +
            "-Schriftart " +
            indexPlus +
            ']"><span class="engraving-mixed engraving-messagevalue">' +
            nameInputVal +
            '</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-popup=".Ruckseitengravur-model-main" data-trigger-id=".' +
            fontNameId +
            '" data-trigger-mainid="' +
            indexPlus +
            '"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-popup=".Ruckseitengravur-model-main" data-input-id=".frontnameinput_' +
            indexPlus +
            '"  data-trigger-mainid="' +
            indexPlus +
            '" data-img-id=".frontnameimg_' +
            indexPlus +
            '" data-trigger-id=".' +
            fontNameId +
            '"><span>löschen</span></button></div></div>';
          $(
            ".halskette_backname_texts .halskette_name_btn .Ohren-input",
          ).hide();
        } else if ($(".popup_name_inputs").val() == "" && index == 0) {
          $(".halskette_backname_texts .halskette_rucks_texts").show();
          $(".halskette_backname_texts .halskette_input_first").show();
          $(".halskette_backname_texts .halskette_header").show();
          fullHtml =
            fullHtml +
            '<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="engraving-messagesection row" data-autom="engraving-message-' +
            indexPlus +
            '"><div class="engraving-messagesection-item"><span class="engraving-name">Name</span><input class="popup_name_inputproperties inputsproperty_' +
            indexPlus +
            '" type="hidden" value="' +
            nameInputVal +
            '" name="properties[Name ' +
            indexPlusText +
            ']"><input class="popup_font_inputproperties fontproperty_' +
            indexPlus +
            '" type="hidden" value="' +
            fontName +
            '" name="properties[_' +
            Zeichenstil +
            "-Schriftart " +
            indexPlus +
            ']"><span class="engraving-mixed engraving-messagevalue">' +
            nameInputVal +
            '</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-popup=".Ruckseitengravur-model-main" data-trigger-id=".' +
            fontNameId +
            '" data-trigger-mainid="' +
            indexPlus +
            '"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-popup=".Ruckseitengravur-model-main" data-input-id=".frontnameinput_' +
            indexPlus +
            '"  data-trigger-mainid="' +
            indexPlus +
            '" data-img-id=".frontnameimg_' +
            indexPlus +
            '" data-trigger-id=".' +
            fontNameId +
            '"><span>löschen</span></button></div></div>';
          $(
            ".halskette_backname_texts .halskette_name_btn .Ohren-input",
          ).hide();
        } else {
          $('[name="properties[Rückseite überspringen]"]').val("Ja");
          $(".halskette_backname_texts .halskette_rucks_texts").html("");
          $(".halskette_backname_texts .halskette_header").show();
          $(
            ".halskette_backname_texts .halskette_name_btn .Ohren-input",
          ).hide();
          // $('.halskette_backname_texts .halskette_rucks_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Rückseite überspringen</span><button class="flagship-collapsable-header-button" type="button" data-popup=".Ruckseitengravur-model-main" data-trigger-id="engraving-change">bearbeiten</button></div>');
          //fullHtml = fullHtml + '<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="engraving-messagesection row" data-autom="engraving-message-'+indexPlus+'"><div class="engraving-messagesection-item"><span style="display:none;">Name: </span><input class="popup_name_inputproperties inputsproperty_'+indexPlus+'" type="hidden" value="'+nameInputVal+'" name="properties[Rückseitengravur]"><input class="popup_font_inputproperties fontproperty_'+indexPlus+'" type="hidden" value="'+fontName+'" name="properties[_Rückseitengravur-Schriftart]"><span class="engraving-mixed engraving-messagevalue">'+nameInputVal+'</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-trigger-id=".'+fontNameId+'" data-trigger-mainid="'+indexPlus+'"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-input-id=".frontnameinput_'+indexPlus+'"  data-trigger-mainid="'+indexPlus+'" data-img-id=".frontnameimg_'+indexPlus+'" data-trigger-id=".'+fontNameId+'"><span>löschen</span></button></div></div>';
        }
      });
    $(".halskette_backname_texts .halskette_rucks_texts").append(fullHtml);
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search,
      );
    }
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
    $(".halskette_backname_texts .backnamecancel_btn").hide();
    console.log("price change");
    getPrice();
    // checkError();
  },
);
// name backside popup save btn 2nd

$(document).on("click", ".Farbig-model-main .image_save_btn", function () {
  $(".halskette_backname_texts .halskette_rucks_texts").html("");
  $(".halskette_backname_texts .halskette_rucks_cancel_databtn").html("");
  $(".Farbig-input").hide();
  var fullHtml = "";
  $(this)
    .parents(".back-popup-js")
    .find(".inner-html")
    .each(function (index) {
      console.log(index);
      var nameInputVal = $(this).find(".popup_name_inputs").val();
      console.log(nameInputVal);
      var fontName = $(this)
        .find(".frontname.name_active")
        .attr("data-fontname");
      var fontNameId = $(this)
        .find(".frontname.name_active")
        .attr("data-nameid");
      var indexPlus = index * 1 + 1;
      var indexPlusText = indexPlus;
      if (indexPlus == 1) {
        var indexPlusText = "";
      }
      var Zeichenstil = $('[name="properties[Zeichenstile]"]:checked').val();
      if (nameInputVal != "") {
        $(".halskette_backname_texts .halskette_rucks_texts").show();
        $(".halskette_backname_texts .halskette_input_first").show();
        $(".halskette_backname_texts .halskette_header").show();
        fullHtml =
          fullHtml +
          '<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="engraving-messagesection row" data-autom="engraving-message-' +
          indexPlus +
          '"><div class="engraving-messagesection-item"><span class="engraving-name">Name:&nbsp </span><input class="popup_name_inputproperties inputsproperty_' +
          indexPlus +
          '" type="hidden" value="' +
          nameInputVal +
          '" name="properties[Name ' +
          indexPlusText +
          ']"><input class="popup_font_inputproperties fontproperty_' +
          indexPlus +
          '" type="hidden" value="' +
          fontName +
          '" name="properties[_' +
          Zeichenstil +
          "-Schriftart " +
          indexPlus +
          ']"><span class="engraving-mixed engraving-messagevalue">' +
          nameInputVal +
          '</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-popup=".Farbig-model-main" data-trigger-id=".' +
          fontNameId +
          '" data-trigger-mainid="' +
          indexPlus +
          '"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-input-id=".frontnameinput_' +
          indexPlus +
          '"  data-trigger-mainid="' +
          indexPlus +
          '" data-popup=".Farbig-model-main" data-img-id=".frontnameimg_' +
          indexPlus +
          '" data-trigger-id=".' +
          fontNameId +
          '"><span>löschen</span></button></div></div>';
        $(".halskette_backname_texts .halskette_name_btn .Ohren-input").hide();
      } else if ($(".popup_name_inputs").val() == "") {
        $(".halskette_backname_texts .halskette_rucks_texts").html("");
        $(".halskette_backname_texts .halskette_header").show();
        $(".halskette_backname_texts .halskette_name_btn .Ohren-input").hide();
        // $('.halskette_backname_texts .halskette_rucks_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Rückseite überspringen</span><button class="flagship-collapsable-header-button" type="button" data-popup=".Ruckseitengravur-model-main" data-trigger-id="engraving-change">bearbeiten</button></div>');
        //fullHtml = fullHtml + '<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="engraving-messagesection row" data-autom="engraving-message-'+indexPlus+'"><div class="engraving-messagesection-item"><span style="display:none;">Name: </span><input class="popup_name_inputproperties inputsproperty_'+indexPlus+'" type="hidden" value="'+nameInputVal+'" name="properties[Rückseitengravur]"><input class="popup_font_inputproperties fontproperty_'+indexPlus+'" type="hidden" value="'+fontName+'" name="properties[_Rückseitengravur-Schriftart]"><span class="engraving-mixed engraving-messagevalue">'+nameInputVal+'</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-trigger-id=".'+fontNameId+'" data-trigger-mainid="'+indexPlus+'"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-input-id=".frontnameinput_'+indexPlus+'"  data-trigger-mainid="'+indexPlus+'" data-img-id=".frontnameimg_'+indexPlus+'" data-trigger-id=".'+fontNameId+'"><span>löschen</span></button></div></div>';
      }
    });
  $(".halskette_backname_texts .halskette_rucks_texts").append(fullHtml);
  if (window.location.hash) {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search,
    );
  }
  $(".Farbig-model-main").removeClass("model-open");
  $("body").removeClass("popup_active");
  $(".halskette_backname_texts .backnamecancel_btn").hide();
  console.log("price change");
  getPrice();
//   checkError();
});

// name back side cancel btn 1st
$(document).on(
  "click",
  ".Ruckseitengravur-model-main .image_cancel_btn",
  function () {
    $("#Ohren").prop("checked", false);
    // $(".halskette-product-add-btn").addClass("disabled");
    var backsideval = $(this)
      .parents(".Ruckseitengravur-model-main")
      .find(".popup_name_inputs")
      .val();
    if (
      $(".halskette_backname_texts .halskette_rucks_texts").children().length >
      0
    ) {
      $(".halskette_backname_texts .halskette_name_btn .Ohren-input").hide();
      console.log("if");
    } else {
      console.log("else");
      $(this)
        .parents(".Ruckseitengravur-model-main")
        .find(".popup_name_inputs")
        .val("");

      if (
        $(
          ".halskette_backname_texts .halskette_rucks_cancel_databtn",
        ).children().length > 0
      ) {
        console.log("if1");
        $(".halskette_backname_texts .halskette_rucks_texts").hide();
        $(".halskette_backname_texts .halskette_name_btn .Ohren-input").hide();
      } else {
        console.log("else1");
        $(".halskette_backname_texts .halskette_rucks_texts").hide();
        $(".halskette_backname_texts .halskette_name_btn .Ohren-input").show();
      }
    }
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search,
      );
    }
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
    var farbig = $(".popup_name_inputproperties").val();
    if (!farbig) {
      $('[name="properties[Zeichenstile]"]').prop("checked", false);
    }
  },
);

// name back side cancel btn 2nd
$(document).on("click", ".Farbig-model-main .image_cancel_btn", function () {
  var backsideval = $(this)
    .parents(".Farbig-model-main")
    .find(".popup_name_inputs")
    .val();
  if (
    $(".halskette_backname_texts .halskette_rucks_texts").children().length > 0
  ) {
    $(".halskette_backname_texts .halskette_name_btn .Ohren-input").hide();
    console.log("if");
  } else {
    console.log("else");
    $(this).parents(".Farbig-model-main").find(".popup_name_inputs").val("");

    if (
      $(".halskette_backname_texts .halskette_rucks_cancel_databtn").children()
        .length > 0
    ) {
      console.log("if1");
      $(".halskette_backname_texts .halskette_rucks_texts").hide();
      $(".halskette_backname_texts .halskette_name_btn .Ohren-input").hide();
    } else {
      console.log("else1");
      $(".halskette_backname_texts .halskette_rucks_texts").hide();
      $(".halskette_backname_texts .halskette_name_btn .Ohren-input").show();
    }
  }
  if (window.location.hash) {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search,
    );
  }
  $(".Farbig-model-main").removeClass("model-open");
  $("body").removeClass("popup_active");
  // });
});

// back side cancel/skip btn
$(document).on("click", ".backnamecancel_btn .halskette_name_btn", function () {
  $(".halskette_backname_texts .halskette_header").hide();
  $(".halskette_backname_texts .halskette_input_first").hide();
  $(this).hide();
  $(".halskette_backname_texts .halskette_rucks_cancel_databtn").html(
    '<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Rückseite überspringen</span><button class="fflagship-collapsable-header-button2" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>',
  );
});

// name back side edit btn
$(document).on(
  "click",
  ".halskette_backname_texts .engraving-editbutton",
  function () {
    var datatriggerId = $(this).attr("data-trigger-id");
    var popupClass = $(this).attr("data-popup");

    var selectedValueNbr = $(".select-trigger .selected-option .list_item")
      .find(".list_item_value")
      .attr("data-number");
    if (!selectedValueNbr) {
      var selectedValueNbr = 1;
    }
    console.log(selectedValueNbr);
    var valueLen = parseInt(selectedValueNbr);
    if (valueLen > 1) {
      var datatriggermainId = parseInt($(this).attr("data-trigger-mainid"));
      var splide = new Splide(".first_slider", {
        pagination: false,
        drag: false, // Disable swipe functionality
      });
      splide.mount();
      splide.go(datatriggermainId - 1);
    }
    window.location.hash = "#popup";
    $(popupClass).addClass("model-open");
    $("body").addClass("popup_active");
    //  $(popupClass+" .popup_fonts").find(datatriggerId).addClass('name_active');
    // $(popupClass+" .popup_fonts").find(datatriggerId).trigger('click');
  },
);

// name back side remove btn
$(document).on(
  "click",
  ".halskette_backname_texts .engraving-remove",
  function () {
    // $(".halskette-product-add-btn").addClass("disabled");
    $("#Ohren").prop("checked", false);
    $(".Farbig-input").show();
    var removemainId = $(this).attr("data-trigger-mainid");
    var removeinputId = $(this).attr("data-input-id");
    var popupClass = $(this).attr("data-popup");
    var removeimageId = $(this).attr("data-img-id");
    var triggerId = $(this).attr("data-trigger-id");
    $(this)
      .parents(".halskette_after_savecontainer")
      .find(".engraving-messagesection-item")
      .html("");

    if ($(".engraving-remove").length == 1) {
      $(this)
        .parents(".halskette_backname_texts ")
        .find(".halskette_rucks_texts")
        .html("");
      $(".halskette_backname_texts .halskette_header").show();
      $(".halskette_backname_texts .halskette_input.backnamecancel_btn").show();
      $(".halskette_backname_texts .halskette_name_btn .Ohren-input").show();
      $(".Ruckseitengravur-model-main")
        .find(
          '.inner-html[data-index="' + removemainId + '"] .popup_name_images',
        )
        .html("");
      $(".Ruckseitengravur-model-main")
        .find(
          '.inner-html[data-index="' + removemainId + '"] .popup_name_inputs',
        )
        .val("");
    } else {
      $(this)
        .parents(".halskette_after_savecontainer")
        .find(".engraving-addbutton")
        .html(
          '<button class="as-buttonlink engraving-buttonlink engraving-addedbutton" type="button" data-popup="' +
            popupClass +
            '" data-trigger-mainid="' +
            removemainId +
            '" data-img-id="' +
            removeimageId +
            '" data-input-id="' +
            removeinputId +
            '" data-trigger-id="' +
            triggerId +
            '"><span>Name hinzufügen</span></button>',
        );
      $(".Ruckseitengravur-model-main")
        .find(
          '.inner-html[data-index="' + removemainId + '"] .popup_name_images',
        )
        .html("");
      $(".Ruckseitengravur-model-main")
        .find(
          '.inner-html[data-index="' + removemainId + '"] .popup_name_inputs',
        )
        .val("");
    }
    var farbig = $(".popup_name_inputproperties").val();
    if (!farbig) {
      $('[name="properties[Zeichenstile]"]').prop("checked", false);
    }
    getPrice();
  },
);

$(document).on(
  "click",
  ".halskette_backname_texts .engraving-addedbutton",
  function () {
    var datatriggerId = $(this).attr("data-trigger-mainid");
    var popupClass = $(this).attr("data-popup");

    var splide = new Splide(".first_slider", {
      pagination: false,
      drag: false, // Disable swipe functionality
    });
    splide.mount();
    splide.go(datatriggerId - 1);
    window.location.hash = "#popup";
    $(popupClass).addClass("model-open");
    $("body").addClass("popup_active");
  },
);

$(document).on(
  "click",
  ".halskette_backname_texts .flagship-collapsable-header-button",
  function () {
    window.location.hash = "#popup";
    $(".Ruckseitengravur-model-main").addClass("model-open");
    $("body").addClass("popup_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(".frontname_1")
      .addClass("name_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(".frontname_1")
      .trigger("click");
  },
);

$(document).on("change", ".halskette_radio input", function () {
  changeAddHalsketteProduct();
  getPrice();
});

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

function changeAddHalsketteProduct() {
  var list_item_value = $(".selected-option span.list_item_value").text();
  var checkedValue = $(".halskette_radio input:checked").attr("id");

  var mainProductvarId = $(".addHalsketteProduct")
    .parents(".product-single__form")
    .find(".product-single__variants")
    .val();
  console.log(mainProductvarId);
  if (
    !(list_item_value == "1 Tier/Person" || list_item_value == "") ||
    checkedValue == "Ja"
  ) {
    var title = list_item_value + " / " + checkedValue;
    var id = $('.addHalsketteProduct option[data-title="' + title + '"]').attr(
      "value",
    );
    $(".addHalsketteProduct").val(id);
  }
}

function addHalsketteProduct() {
  var mainProductvarId = getRandomInt(10000, 99999);
  var items = [];
  var bundleItem = [];

  var checkedValue = $(".halskette_radio input:checked").val();

  // --- Add Handzeichnung (Ja option) ---
  if (checkedValue == "Ja") {
    var id = $(".handzeichnung").val();
    if (id && id !== "") {
      // Prevent blank ID
      items.push({
        id: id,
        quantity: 1,
        properties: { _bundleWithItem: mainProductvarId },
      });
      bundleItem.push(id);
    }
  }

  // --- Add Zeichenstil ---
  var Zeichenstil = $("#Farbig").is(":checked");
  if (Zeichenstil) {
    var id = $(".ruckseitengravur").val();

    if (id && id !== "") {
      // Prevent blank ID
      items.push({
        id: id,
        quantity: 1,
        properties: { _bundleWithItem: mainProductvarId },
      });
      bundleItem.push(id);
    }
  }

  console.log(items); // Only valid items will appear

  $(".bundleItem").val(mainProductvarId);

  // --- Add to cart only if items exist ---
  if (items.length > 0) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: { items: items },
      success: function () {
        console.log("Items added to cart");
      },
    });
  }
}

function getPrice() {
  var id = $("[data-product-select]").val();
  var price =
    $(`[data-product-select] option[value="${id}"]`).attr("data-price") * 1;
  console.log(price);
  var personen = $(".halskette_personen").val();
  if (!(personen == "1" || personen == "" || personen == undefined)) {
    var halskette_personen_price =
      $('.addHalsketteProduct option[data-title="' + personen + '"]').attr(
        "data-price",
      ) * 1;
    price = price + halskette_personen_price * 1;
    console.log(price);
  }
  var checkedValue = $(".halskette_radio input:checked").attr("id");

  if (checkedValue == "Ja") {
    var handzeichnung_price = $(".handzeichnung").attr("data-price") * 1;
    price = price + handzeichnung_price;
    console.log(price);
  }
  var Zeichenstil = $("#Farbig").is(":checked");
  if (Zeichenstil) {
    var ruckseitengravur_price = $(".ruckseitengravur").attr("data-price") * 1;
    price = price + ruckseitengravur_price;
    console.log(price);
  }
  var formattedAmount = theme.Currency.formatMoney(
    price,
    theme.settings.moneyFormat,
  );
  $("[data-product-price]").text(formattedAmount);
}

function uploadkit() {
  if ($(".uploadkit-thumbnail").children().length == 0) {
    $(".custom_uploadkit .uploadkit-uploader .image_save").remove();
  }
  $(".uploadkit-thumbnail").each(function (index) {
    var image = $(this);
    var field = image.next(".uploadkit-field");
    var wrapper = image.closest(".uploadkit-main-wrapper");
    //console.log($(this).find('.uploadkit-main-wrapper').length);
    if (wrapper.length === 0) {
      wrapper = $('<div class="uploadkit-main-wrapper"></div>');
      image.add(field).wrapAll(wrapper);
      $(this).wrap($('<div class="uploadkit-wrapper-img"></div>'));
      $(this).wrap($('<div class="wrapper-img"></div>'));
    }
    //console.log($('.uploadkit-thumbnail').children().length);

    // console.log($('.uploadkit-main-wrapper').length);
    if (
      $(".uploadkit-main-wrapper").length == 2 ||
      $(".uploadkit-main-wrapper").length == 1
    ) {
      $(".uploadkit-main-wrapper").css("width", "45%");
    }
    if (
      $(".uploadkit-main-wrapper").length == 3 ||
      $(".uploadkit-main-wrapper").length == 4 ||
      $(".uploadkit-main-wrapper").length == 5
    ) {
      $(".uploadkit-main-wrapper").css("width", "31%");
    }
    if ($(".custom_uploadkit .uploadkit-uploader .image_save").length == 0) {
      if ($(".uploadkit-main-wrapper").length >= 1) {
        $(".custom_uploadkit")
          .find(".uploadkit-button.uploadkit-button-uploaded")
          .before('<button type="button" class="image_save">Sichern</button>');
        $(".custom_uploadkit .uploadkit-uploader")
          .find(".uploadkit-button.uploadkit-button-uploaded")
          .addClass("uploaded_button_full");
      }
    }
  });
}
setInterval(uploadkit, 800);

$(document).on("click", ".uploadkit-wrapper-img", function (event) {
  if ($(event.target).is("div.wrapper-img")) {
    $(this).find("img.uploadkit-thumbnail").trigger("click");
  }
});
$(document).on("click", ".image_save", function (event) {
  $(".halsketteupload_header").hide();
  $(".halsketteupload_content").hide();
  $(".after_upload_photo").show();

  // setTimeout(function(){
  $("html, body").animate(
    {
      scrollTop: $("#foto").offset().top - 160,
    },
    400,
  );
  // },500);
});

$(document).on("click", ".halsketteupload_edit_text", function (event) {
  $(".after_upload_photo").hide();
  $(".halsketteupload_header").show();
  $(".halsketteupload_content").show();
});

$(document).on(
  "keyup",
  ".Ruckseitengravur-model-main .inner-html .popup_name_inputs",
  function () {
    var valDat = $(this).val();
    console.log(valDat);
    $(this)
      .parents(".Ruckseitengravur-model-main .inner-html")
      .find(".popup_name_images")
      .html(valDat);
    // $('.Ruckseitengravur-model-main .inner-html[data-index="1"] .frontnameimg_1').html(valDat);

    var inputValue = $(this)
      .parents(".Ruckseitengravur-model-main .inner-html.is-active")
      .find(".frontnameinput_1")
      .val();
    var convertedValue = inputValue;
    var elements = $(this)
      .parents(".Ruckseitengravur-model-main .inner-html.is-active")
      .find(".frontname_4.name_active");
    if (elements.length > 0) {
      var words = inputValue.split(" ");
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        var wordFirstCharacter = word.charAt(0);
        var wordRestOfText = word.substr(1).toLowerCase();
        words[i] = wordFirstCharacter + wordRestOfText;
      }
      var convertedValue = words.join(" ");
      $(this).val(convertedValue);
    }
    $(this)
      .parents(".Ruckseitengravur-model-main .inner-html.is-active")
      .find(".popup_name_images")
      .html(convertedValue);

    updateFontSize($(this));
  },
);

$(document).on(
  "keyup",
  ".Farbig-model-main .inner-html .popup_name_inputs",
  function () {
    var valDat = $(this).val();
    console.log(valDat);
    $(this)
      .parents(".Farbig-model-main .inner-html")
      .find(".popup_name_image")
      .html(valDat);
    // $('.Ruckseitengravur-model-main .inner-html[data-index="1"] .frontnameimg_1').html(valDat);

    var inputValue = $(this)
      .parents(".Farbig-model-main .inner-html.is-active")
      .find(".frontnameinput_1")
      .val();
    var convertedValue = inputValue;
    var elements = $(this)
      .parents(".Farbig-model-main .inner-html.is-active")
      .find(".frontname_4.name_active");
    if (elements.length > 0) {
      var words = inputValue.split(" ");
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        var wordFirstCharacter = word.charAt(0);
        var wordRestOfText = word.substr(1).toLowerCase();
        words[i] = wordFirstCharacter + wordRestOfText;
      }
      var convertedValue = words.join(" ");
      $(this).val(convertedValue);
    }
    $(this)
      .parents(".Farbig-model-main .inner-html.is-active")
      .find(".popup_name_image")
      .html(convertedValue);

    updateFontSize($(this));
  },
);

function updateFontSize(item) {
  var text = item.val();
  var characters = text.length;
  var num = item.attr("data-number");
  console.log(num);
  console.log(characters);
  var popupName1 = $(
    ".Ruckseitengravur-model-main .frontnameimg_1, .Farbig-model-main .frontnameimg_1",
  );
  var popupName2 = $(
    ".Ruckseitengravur-model-main .frontnameimg_2, .Farbig-model-main .frontnameimg_2",
  );
  var popupName3 = $(
    ".Ruckseitengravur-model-main .frontnameimg_3, .Farbig-model-main .frontnameimg_3",
  );
  var popupName4 = $(
    ".Ruckseitengravur-model-main .frontnameimg_4, .Farbig-model-main .frontnameimg_4",
  );
  if (characters <= 2) {
    popupName1.css("font-size", "70px");
    popupName2.css("font-size", "75px");
    popupName3.css("font-size", "70px");
    popupName4.css("font-size", "90px");
  } else if (characters == 3) {
    popupName1.css("font-size", "65px");
    popupName2.css("font-size", "75px");
    popupName3.css("font-size", "65px");
    popupName4.css("font-size", "80px");
  } else if (characters == 4) {
    popupName1.css("font-size", "65px");
    popupName2.css("font-size", "72px");
    popupName3.css("font-size", "65px");
    popupName4.css("font-size", "76px");
  } else if (characters == 5) {
    popupName1.css("font-size", "62px");
    popupName2.css("font-size", "70px");
    popupName3.css("font-size", "62px");
    popupName4.css("font-size", "75px");
  } else if (characters == 6) {
    popupName1.css("font-size", "62px");
    popupName2.css("font-size", "67px");
    popupName3.css("font-size", "62px");
    popupName4.css("font-size", "70px");
  } else if (characters == 7) {
    popupName1.css("font-size", "60px");
    popupName2.css("font-size", "64px");
    popupName3.css("font-size", "60px");
    popupName4.css("font-size", "66px");
  } else if (characters == 8) {
    popupName1.css("font-size", "57px");
    popupName2.css("font-size", "59px");
    popupName3.css("font-size", "57px");
    popupName4.css("font-size", "62px");
  } else if (characters == 9) {
    popupName1.css("font-size", "55px");
    popupName2.css("font-size", "55px");
    popupName3.css("font-size", "55px");
    popupName4.css("font-size", "58px");
  } else if (characters == 10) {
    popupName1.css("font-size", "50px");
    popupName2.css("font-size", "52px");
    popupName3.css("font-size", "50px");
    popupName4.css("font-size", "55px");
  } else if (characters == 11) {
    popupName1.css("font-size", "47px");
    popupName2.css("font-size", "49px");
    popupName3.css("font-size", "47px");
    popupName4.css("font-size", "55px");
  } else if (characters == 12) {
    popupName1.css("font-size", "45px");
    popupName2.css("font-size", "47px");
    popupName3.css("font-size", "45px");
    popupName4.css("font-size", "52px");
  } else if (characters == 13) {
    popupName1.css("font-size", "42px");
    popupName2.css("font-size", "45px");
    popupName3.css("font-size", "42px");
    popupName4.css("font-size", "50px");
  } else if (characters == 14) {
    popupName1.css("font-size", "40px");
    popupName2.css("font-size", "43px");
    popupName3.css("font-size", "40px");
    popupName4.css("font-size", "47px");
  } else if (characters == 15) {
    popupName1.css("font-size", "36px");
    popupName2.css("font-size", "41px");
    popupName3.css("font-size", "36px");
    popupName4.css("font-size", "45px");
  } else if (characters == 16) {
    popupName1.css("font-size", "35px");
    popupName2.css("font-size", "40px");
    popupName3.css("font-size", "35px");
    popupName4.css("font-size", "46px");
  }
}

// Scroll on touch code
// Scroll on touch code for all elements matching the selector
function touchScroll($bind = "") {
  const sliders = document.querySelectorAll($bind);

  if (!sliders.length) {
    // console.error(`No elements found with selector '${$bind}'.`);
    return;
  }

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let velX = 0;
    let momentumID;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      cancelMomentumTracking();
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
      beginMomentumTracking();
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; // Scroll fast
      var prevScrollLeft = slider.scrollLeft;
      slider.scrollLeft = scrollLeft - walk;
      velX = slider.scrollLeft - prevScrollLeft;
    });

    slider.addEventListener("wheel", (e) => {
      cancelMomentumTracking();
    });

    function beginMomentumTracking() {
      cancelMomentumTracking();
      momentumID = requestAnimationFrame(momentumLoop);
    }

    function cancelMomentumTracking() {
      cancelAnimationFrame(momentumID);
    }

    function momentumLoop() {
      slider.scrollLeft += velX;
      velX *= 0.95;
      if (Math.abs(velX) > 0.5) {
        momentumID = requestAnimationFrame(momentumLoop);
      }
    }
  });
}

// Usage example
touchScroll(".popup_fonts");

function checkError() {
  var personen = $(".halskette_personen").val();
  var inputproperties = $(".popup_name_inputproperties").val();
  var handymodell = $(".input-handymodell").val();
  if (personen == "" || inputproperties == undefined || handymodell == "") {
    $(".add-to-cart").addClass("disabled");

    if (inputproperties != undefined) {
      $(".line-item-property__field.radio-buttons").removeClass("error-text");
    }
    if (personen != "") {
      $(".select-trigger.select-personen").removeClass("error-text");
    }
    if (handymodell != "") {
      $(".select-trigger.select-handymodell").removeClass("error-text");
    }
  } else {
    $(".select-trigger").removeClass("error-text");
    $(".add-to-cart").removeClass("disabled");
    $(".line-item-property__field.radio-buttons").removeClass("error-text");
    $(".error").hide();
  }
}

// end if

$(document).on(
  "click",
  ".halskette-product-add-btn.add-to-cart.disabled",
  function (event) {
    event.preventDefault();
    var personen = $(".halskette_personen").val();
    var handymodell = $(".input-handymodell").val();
    console.log("personen", personen);
    var inputproperties = $(".popup_name_inputproperties").val();
    console.log("inputproperties", inputproperties);
    if (personen == "" || inputproperties == undefined) {
      $(".error").show();
      if (personen == "" || personen == undefined) {
        $(".select-trigger.select-personen").addClass("error-text");
      }
      if (handymodell == "" || handymodell == undefined) {
        $(".select-trigger.select-handymodell").addClass("error-text");
      }
      if (inputproperties == undefined || inputproperties == "") {
        $(".line-item-property__field.radio-buttons").addClass("error-text");
      }
    }
  },
);

$(document).on("change", ".radio-buttons #Ohren", function () {
//   checkError();
  getPrice();
});
var mobileData;
var brandModelElement = document.getElementById("brand_model");
if (brandModelElement) {
  mobileData = JSON.parse(brandModelElement.textContent);
  // Now you can work with mobileData
}
// Function to populate the mobile models select box
function populateModels(brand) {
  const modelsSelect = $("#custom-select-handymodell");
  modelsSelect.empty();
  console.log(modelsSelect);
  if (mobileData) {
    if (mobileData.hasOwnProperty(brand)) {
      mobileData[brand].forEach(function (model) {
        modelsSelect.append(
          `<li value="${model}"><div class="list_item"><span data-value="${model}" class="list_item_value">${model}</span></div></li>`,
        );
      });
    }
  }
}
populateModels("options");

$(document).on("click", "#custom-select-handymodell li", function () {
  var selectedOption = $(this).html();
  var selectedValue = $(this).attr("value");
  $(".Namen-model-main .frontname").removeClass("name_active");
  var selectedDataVal = $(this)
    .parents(".halskette_selecteditems")
    .find(".select-trigger .selected-option .list_item .list_item_value")
    .attr("data-value");
  $(".halskette_frontname_texts .halskette_name_texts").html("");
  $(".halskette_frontname_texts .frontnamecancel_btn").show();
  $(".halskette_frontname_texts .halskette_name_btn .Ohren-input").show();
  $(".Namen-model-main #popup_name_image").html("");
  $(".Namen-model-main .popup_name_inputs").val("");
  $(".Namen-model-main #frontname_1").addClass("name_active");
  $(".halskette_frontname_texts .halskette_header").show();
  $(".halskette_frontname_texts .halskette_input_first").show();
  $(".halskette_frontname_texts .halskette_name_cancel_databtn").html("");
  $(this)
    .parents(".custom-select")
    .find(".selected-option")
    .html(selectedOption);
  $(".options").slideUp("fast");
  $(".input-handymodell").val(selectedValue);
  $(".options").removeClass("selected_open");
  $(this)
    .parents(".custom-select")
    .find(".select-trigger")
    .removeClass("selector_open");
//   checkError();
});

var interval = setInterval(checkURL, 1000);
function checkURL() {
  var currentURL = window.location.href;
  if (currentURL.indexOf("#") === -1) {
    $(".aufFoto-model-main").removeClass("model-open");
    $(".Weitere-model-main").removeClass("model-open");
    $(".Zeichnungsstil-model-main").removeClass("model-open");
    $(".Handzeichnung-model-main").removeClass("model-open");
    $(".Namen-model-main").removeClass("model-open");
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body.template-product").removeClass("popup_active");
  }
}

// $(".halskette-product-add-btn").addClass("disabled");
$(".halskette-product-add-btn").removeClass("disabled");